// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__X9nfx"};